import { v4 as uuid4, v5 as uuid5 } from 'uuid';
//const UUID_NS_DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const UUID_NS_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
//const UUID_NS_OID = '6ba7b812-9dad-11d1-80b4-00c04fd430c8';
//const UUID_NS_X500 = '6ba7b814-9dad-11d1-80b4-00c04fd430c8';
export const UUID_NS_TLMD = uuid5('http://om-app.com/tlmd', UUID_NS_URL);
export const UUID_NS_TLMD_SYSTEM = uuid5('http://om-app.com/tlmd/system', UUID_NS_TLMD);
export const UUID_NS_TLMD_SYSTEM_ROLE = uuid5('http://om-app.com/tlmd/system/role', UUID_NS_TLMD_SYSTEM);
export const getSystemRoleId = (roleName) => {
    return uuid(UUID_NS_TLMD_SYSTEM_ROLE, roleName);
};
export const uuid = (nsUUID, name) => {
    return nsUUID === undefined
        ? uuid4()
        : name === undefined
            ? uuid5(uuid4(), nsUUID)
            : uuid5(name, nsUUID);
};
